import React, { useCallback } from 'react';
import Router from 'next/router';

import ROUTES from 'src/routes';

import useUI from 'hooks/use-ui';
import useUser from 'hooks/use-user';
import useCart from 'hooks/use-cart';

import { ModalWrapper } from 'shared/modals/v2-wrapper';
import { DialogWrapper } from 'shared/modals/v2-dialog-wrapper';
import { DesktopOnly, MobileOnly } from 'shared/components';

import { callNativeMethod } from 'src/mobile-ecomm/hooks/use-mobile-native-bridge';
import { ModalObserver } from '../modal-observer';
import { OrderStatusModal } from './order-status-modal';

function useOrderStatus({ onClose }) {
  const user = useUser();
  const Cart = useCart();
  const { isDutchieMain, isMobileEcommApp } = useUI();

  const handleClose = useCallback(() => {
    user.viewOrderId = '';

    if (isDutchieMain) {
      Router.replace(ROUTES.ORDERS);
    } else {
      if (isMobileEcommApp) {
        Cart.clearOrder();
        callNativeMethod(`onOrderComplete`);
      }
      onClose();
    }
  }, [isDutchieMain, isMobileEcommApp, onClose, user]);

  return {
    handleClose,
  };
}

function OrderStatusWrapper({ open, onClose, containerProps }) {
  const { handleClose } = useOrderStatus({ onClose });

  return (
    <>
      <MobileOnly>
        <DialogWrapper open={open} onClose={handleClose}>
          <OrderStatusModal containerProps={containerProps} onClose={handleClose} />
        </DialogWrapper>
      </MobileOnly>

      <DesktopOnly>
        <ModalWrapper open={open} onClose={handleClose}>
          <OrderStatusModal containerProps={containerProps} onClose={handleClose} />
        </ModalWrapper>
      </DesktopOnly>
    </>
  );
}

export const OrderStatusContoller = ({ name }) => (
  <ModalObserver name={name}>{(props) => <OrderStatusWrapper {...props} />}</ModalObserver>
);
